import { QueryClient } from '@tanstack/react-query'

export const APIQueryClient = new QueryClient()
